import { createSelector } from 'reselect';

const content = (state: any) => state.offer.data;

export const selectorCards = createSelector(content, data => {
    let currentGapIndex = 0;
    let cards: any = [[]];
    let startTable: any = [];
    let data_content: any = [];

    if (data && data.attributes && data.attributes.Content) {
        data.attributes.Content.map((item: any, index: any) => {
            if (item.Content && item.Content.length > 0) {
                item.Content.map((el: any) => {
                    if (el.type == 'heading' && el.level == 3) {
                        return (el.level = '2_3');
                    }
                });
            }
            data_content.push(item);
        });

        data_content.map((item: any, index: any) => {
            if (item.__component === 'editor.gap' && item.Gap) {
                if (startTable.length > 0) {
                    cards[currentGapIndex] = [
                        ...cards[currentGapIndex],
                        {
                            __component: 'editor.price-table',
                            values: startTable,
                        },
                    ];
                    startTable = [];
                }
                currentGapIndex = currentGapIndex + 1;
                cards = [...cards, []];
                return;
            }

            if (item.__component === 'editor.price-row') {
                startTable.push(item);
            } else {
                if (startTable.length > 0) {
                    cards[currentGapIndex] = [
                        ...cards[currentGapIndex],
                        {
                            __component: 'editor.price-table',
                            values: startTable,
                        },
                    ];
                    startTable = [];
                }
                cards[currentGapIndex] = [...cards[currentGapIndex], item];
            }

            if (index + 1 === data_content.length) {
                if (startTable.length > 0) {
                    cards[currentGapIndex] = [
                        ...cards[currentGapIndex],
                        {
                            __component: 'editor.price-table',
                            values: startTable,
                        },
                    ];
                    startTable = [];
                }
            }
        });
    }

    return cards;
});
